import styled from 'styled-components';
import { PRIMARY } from '../../../utils/colors';

export default styled.div`
  background-color: ${PRIMARY};
  border-radius: 0 0 0.3rem 0.3rem;
  padding: 2rem 1rem 1rem;
  transform: translateY(-1rem);
`;
